import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disablePickupTimeSelection',
  initialState: false,
  reducers: {
    setDisablePickupTimeSelection(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisablePickupTimeSelection } = slice.actions;

export default slice.reducer;
